import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';

const DEFAULT_TITLE = 'Give Santa';
const DEFAULT_DESCRIPTION =
  'Santa is still on vacation — and Christmas is coming. Create a personalized 10-minute Christmas adventure for someone you love. One price: $25.';

@Injectable({ providedIn: 'root' })
export class SiteTitleStrategy extends TitleStrategy {
  constructor(
    private readonly title: Title,
    private readonly meta: Meta,
  ) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.title.setTitle(this.buildTitle(snapshot) ?? DEFAULT_TITLE);
    this.meta.updateTag({
      name: 'description',
      content: this.findDescription(snapshot.root) ?? DEFAULT_DESCRIPTION,
    });
  }

  private findDescription(route: ActivatedRouteSnapshot): string | undefined {
    let description: string | undefined;
    for (let current: ActivatedRouteSnapshot | null = route; current; current = current.firstChild) {
      description = current.data['description'] ?? description;
    }
    return description;
  }
}
